import React, { lazy } from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function FinalCTASection() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-12 md:py-16 px-4 bg-brand-deep text-white text-center" data-id="element-84">
      <div className="max-w-4xl mx-auto" data-id="element-85">
        <h2 className="text-3xl md:text-6xl font-black mb-6 leading-tight text-brand-primary" data-id="element-86">
          El oficio que aprendés hoy es la libertad que tenés mañana.
        </h2>

        <div className="bg-brand-navy p-6 md:p-12 rounded-3xl border border-white/10 mb-8 max-w-2xl mx-auto shadow-2xl" data-id="element-87">
          <p className="text-xl font-bold text-blue-50 mb-6" data-id="element-88">
            ⏰ Precio de $19.990 disponible solo por tiempo limitado.
          </p>
          <div className={`flex justify-center gap-4 mb-8 ${isUrgent ? 'animate-blink' : ''}`} data-id="element-89">
            <div className={`text-6xl md:text-7xl font-black ${isUrgent ? 'text-red-500' : 'text-white'}`} data-id="element-90">
              {formatTime(minutes)}
            </div>
            <div className="text-6xl md:text-7xl font-black text-blue-400" data-id="element-91">
              :
            </div>
            <div className={`text-6xl md:text-7xl font-black ${isUrgent ? 'text-red-500' : 'text-white'}`} data-id="element-92">
              {formatTime(seconds)}
            </div>
          </div>
          <p className="text-red-400 font-bold text-lg" data-id="element-93">
            Después vuelve a $49.900 ARS.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-8" data-id="element-94">
          <div className="text-blue-400 line-through font-bold text-2xl mb-2" data-id="element-95">
            $49.900 ARS
          </div>
          <div className="text-6xl font-black text-white mb-8" data-id="element-96">$19.990 ARS</div>
          <CTAButton text="🔥 → QUIERO EL PACK AHORA" isLink={true} className="py-5 text-xl" data-id="element-97" />

          <div className="mt-8" data-id="element-98">
            <img src="https://cdn.magicpatterns.com/uploads/iNdd7dNPFTmkMXnAUq87Qt/jo3l6snt.png" alt="Garantía 7 Días de Reembolso" className="w-48 mx-auto" width="192" height="192" loading="lazy" data-id="element-99" />
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm md:text-base text-blue-50 font-medium" data-id="element-100">
          <span className="flex items-center gap-2" data-id="element-101">
            <LockIcon className="w-5 h-5" data-id="element-102" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-103">
            <ZapIcon className="w-5 h-5 text-brand-amber" data-id="element-104" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-105">
            <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-106" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2 md:mt-0 md:w-auto" data-id="element-107">
            <CreditCardIcon className="w-5 h-5" data-id="element-108" /> Mercado Pago | Tarjeta |
            Transferencia
          </span>
        </div>
      </div>
    </section>;
}